// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { dashboardBuilderLegend16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-dashboard-builder-legend': IconDashboardBuilderLegend;
    }
}

/**
 * The icon component for the 'dashboardBuilderLegend' icon
 */
export class IconDashboardBuilderLegend extends IconSvg {
    public constructor() {
        super(dashboardBuilderLegend16X16);
    }
}

registerIconSvg('icon-dashboard-builder-legend', IconDashboardBuilderLegend);
export const iconDashboardBuilderLegendTag = 'nimble-icon-dashboard-builder-legend';
